exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-toolbar mat-chip-list {\n  margin-left: 20px; }\n\nmat-card-content.subproduct div.name {\n  padding: 15px; }\n\nmat-card-content.subproduct div.mat-input-suffix {\n  margin-left: 6px; }\n\nmat-card-content.subproduct button {\n  min-width: 0;\n  line-height: 20px;\n  padding: 0;\n  margin: 12px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ProductsModule/ProductEditComponent/product-edit.component.scss
// module id = ../../../../../src/ProductsModule/ProductEditComponent/product-edit.component.scss
// module chunks = main